import React,{useRef, useState, useEffect, useContext} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Alert, Dropdown} from "react-bootstrap";
import {setUrlParam }				from "../utils/functions";
import Select						from "react-select";
import Footer						from "../layouts/Footer";
import Sidebar						from "../layouts/Sidebar";
import Header						from "../layouts/Header";
import DialogProjectSettings		from "../layouts/DialogProjectSettings";
import parse						from 'html-react-parser';
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import {et, energyTypes}			from "../data/energyTypes";
import Country						from "../classes/Country";
import atlasApi						from "../utils/atlasapi";
import authApi						from "../utils/authApi";
import Loader						from "../components/Loader";
import Filter						from "../components/Filter";
import UserMenu						from "../components/UserMenu";
import ListStyle					from "../components/ListStyle";
import IconSelector					from "../components/IconSelector";
import Pagination					from "../components/Pagination";
import {Sliders, Star, Files, DotsThreeVertical, PencilSimple, Trash, FloppyDisk, UploadSimple, Polygon} from "@phosphor-icons/react";
import DialogPrompt					from "../layouts/DialogPrompt";
import globalContext				from "../utils/globalContext";
import ExportAllProjects			from "../components/ExportAllProjects";



import {formatDate, timeAgo, sortByDate, sortStrings} from  "../utils/functions";
import DataTable					from 'react-data-table-component';


import TurfCentroid from '@turf/centroid';
import TurfLength from '@turf/length';
import TurfCenterOfMass from '@turf/center-of-mass';
import TurfBBox from '@turf/bbox';
import TurfArea from '@turf/area';
import {points} from '@turf/helpers';
import center from '@turf/center';
import MapboxDraw from "@mapbox/mapbox-gl-draw";


import {drawUtils} from "../utils/drawUtils";
import drawTheme from "../utils/drawUtilsTheme";
import turbineControl from "../utils/turbineControl";
import boundaryMode from "../utils/boundaryMode";
import limited_simple_select from "../utils/simple_select";
import limited_direct_select from "../utils/direct_select";
import DialogProject from "../layouts/DialogProject";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import {baseMaps} from "../data/baseMaps";


import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax

//import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
 
mapboxgl.accessToken = key;
MapboxDraw.modes.simple_select = {...MapboxDraw.modes.simple_select, ...limited_simple_select};
MapboxDraw.modes.direct_select = {...MapboxDraw.modes.direct_select, ...limited_direct_select};

const Draw = new MapboxDraw({
	displayControlsDefault: false,
	controls: {
		polygon: false,
		line_string:false,
		trash: false,
		boundary_mode:true
	},
	userProperties:true,
	styles: drawTheme,
	modes: Object.assign({
		boundary_mode: boundaryMode,
	}, MapboxDraw.modes)
});

var du;  //drawutils
var tc;
var centerPoint;

	
export default function WindProjects() {
		
	document.body.className="projects";
	
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	
	
	const context = useContext(globalContext);

	var statusSel		= params.get("status")	? params.get("status").split(",")	: [];
	var phaseSel		= params.get("phase")	? params.get("phase").split(",")	: [];
	var countrySel		= params.get("country") ? params.get("country").split(",")	: [];
	var energySel		= params.get("energy")	? params.get("energy").split(",")	: [];
	var searchSel		= params.get("search")	? params.get("search")				: "";
	
	var icons = {};
	et.map((e)=>{icons[e.label] = e.icon});
	
	var filterEnergyOpts			= [...et];
	filterEnergyOpts.shift();
	
	const [pageTitle,setPageTitle]		= useState('Projects');
	const [user,setUser]				= useState({});
	const [refresh,setRefresh]				= useState('');
	const [recent,setRecent]			= useState([]);
	const [listStyle,setListStyle]		= useState('list');
	const [listSort,setListSort]		= useState({sortBy:'name', sortOrder:'asc'});
	const [settingsDialog,setSettingsDialog]			= useState({open:false});
	const [dialogPrompt,setDialogPrompt]			= useState({open:false});
	const [errors,setErrors]			= useState(new Set()); //what layer to show, default show owners
	const mapContainer					= useRef(null);
	const map							= useRef(null);
	const [zoom, setZoom]				= useState(8);
	const [saveBtn,setSaveBtn]			= useState(false); //status variable set when all data is loaded
	const [uploadLayer,setUploadLayer]	= useState({open:false}); //displays uploadLayer dialog
	
	//filter component references
	const phaseComp = React.createRef();
	const statusComp = React.createRef();
	const countryComp = React.createRef();
	const energyComp = React.createRef();
	
	
	/*
	options of the sort by select box
	*/

	const filterPhaseOpts		= projectPhaseColors.asOpts();
	const filterStatusOpts		= projectStatusColors.asOpts();
	
		
	const [needle, setNeedle]					= useState(searchSel);
	const [filterPhase, setFilterPhase]					= useState(new Set(phaseSel));
	const [filterCountry, setFilterCountry]			= useState(new Set(countrySel));
	const [filterEnergy, setFilterEnergy]					= useState(new Set(energySel));
	const [filterStatus, setFilterStatus]					= useState(new Set(statusSel));
	const [filterFav, setFilterFav]				= useState(false);
	const [data,setData]						= useState([]);
	const [showFilters,setShowFilters]			= useState(false);
	const [projectStatuses,setProjectStatuses]	= useState([]);
	const [loaded,setLoaded]					= useState(false); //status variable set when all data is loaded
	const [addProject,setAddProject]			= useState(false); //displays new project dialog if true
	
	
	
	const sanitizesettings = (settings) => {
		
		if(!settings.projects){
			settings.projects = {
				filters : {
					phase : [],
					status: [],
					country : []
				}
			};
		}
		if(!settings.recentProjects)
			settings.recentProjects = [];
	}
	const getData = ()=>{
		Promise.all([
			atlasApi.getToken()
		])
		.then((res) => {
			const dataRequests = [
				authApi.getUser()
			];
			
			return Promise.all(dataRequests);
		})
		.then((res) => {
			 
			const dataRequests = [
				atlasApi.getProjects(res[0].userDetails),
				Promise.resolve(res[0])
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		}).then((responses)=>{
			
			var myJson				= JSON.parse(responses[0].replaceAll("NaN", "0"));
			var user				= responses[1];
			sanitizesettings(user.settings);
			var filters				= user.settings?.projects?.filters ?? user.settings.filters;
			
			var recentP = user.settings.recentProjects.map((rp)=>{
				var idx = myJson.projects.findIndex((p)=>{
					if((typeof rp === "object" || typeof rp === 'function') && (rp !== null)){
						return parseInt(rp.projectId) == p.projectid;
					}
					else{
						return parseInt(rp) == p.projectid;
					}
				});
				if(idx != -1){
					var a = myJson.projects[idx];
					a.lastOpened = (rp.lastOpened ? rp.lastOpened : 0);
					return a;
				}
				return false;
			});
			
			setUser(user);
			setRecent(recentP);
			
			if(!filterStatus.length && filters.status && filters.status.length && statusComp.current){
				selectFilter("status", filters.status, setFilterStatus);
				statusComp.current.setValue(filters.status.map((i)=>{return projectStatusColors.getOpt(i)}));
			}
			if(!filterPhase.length && filters.phase && filters.phase.length && phaseComp.current){
				selectFilter("phase", filters.phase, setFilterPhase);
				phaseComp.current.setValue(filters.phase.map((i)=>{return projectPhaseColors.getOpt(i)}));
			}
			if(!filterCountry.length && filters.country && filters.country.length){
				selectFilter("country", filters.country, setFilterCountry)
				//countryComp.current.setValue(Country.get(filters.country));
			}
			if(!filterEnergy.length && filters.energy && filters.energy.length){
				selectFilter("energy", filters.energy, setFilterEnergy);
				//energyComp.current.setValue(energyTypes.get(filters.energy));
			}
			
			if(!filterFav && filters.favorites){
				selectFilter("favorites", filters.favorites, setFilterFav);
				if(filters.favorites)
					setFilterFav(filters.favorites)
			}
			if(user.settings.projects.listStyle){
				setListStyle(user.settings.projects.listStyle);
			}
			if(user.settings.projects.sort){
				setListSort(user.settings.projects.sort);
			}
			
			
			
			var poly = [];
			
			myJson.projects.map((item)=>{
				//cleanup some newline characters,etc from the names
				item.name = item.name.trim();
				if(item.lon && item.lat)
					poly.push([item.lon, item.lat]);
				//
				//... other validation and cleanuup tasks can be added
			})
			
			myJson.poly = points(poly);
	
			
			centerPoint						= center(myJson.poly).geometry.coordinates;

			setData(myJson);
			setLoaded(true);
			document.title = process.env.REACT_APP_DOC_TITLE;

		}).catch((e)=>{
			console.log(e);
			setLoaded(true);
			setErrors(p => [...p, 'Error fetching data']); //add this error to previous errors
		});
		return;


	};
	

	useEffect(()=>{
		getData();
	},[])		
	
	var selectFilter = (filter, opts, callback) => {
		
		if(Array.isArray(opts)){
			//add filter to url
			setUrlParam(filter, opts.map(obj => obj.value).join(","));
			//we use a Set so to avoid repeat options
			callback(new Set(opts));
		}
		else {
			setUrlParam(filter, opts);
			callback(opts);
		}//update user settings
		saveFilter(filter, (Array.isArray(opts) ? opts.filter(a => a.length) : opts));
	};

	var search = (a) => {
		
		if(a.target.value.length>2 || !a.target.value.length) {
			setUrlParam("search", a.target.value);
			setNeedle(a.target.value)
		}
	};
	
	
	const searchNeedle = (item) => {
		
		if(needle.length < 3)
			return true;
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(
			item.name && item.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(new RegExp(needle.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i"))
			||
			item.municipality && item.municipality.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(new RegExp(needle.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i"))
		)
	}
	function highlight(str, group1, group2) {
		return "<span class=bg-warning>"+str+"</span>";
	}
	
	const handleSetFavorite = function(e, row){
		
		e.stopPropagation();
		e.preventDefault();
		
		const elem = document.querySelector("#star-"+row.projectid);
		const isActive = elem.classList.contains("active");
		const projectid = elem.dataset.projectid;
		
		const proj = data.projects.find((p)=>{return p.projectid == projectid});
		
		row.isFavorite = !isActive;
		
		setRefresh(Math.random());
		
		atlasApi.setFavorite(!isActive, projectid, user.userDetails).then((res)=>{
			if(res.id){
				document.querySelector("#star-"+row.projectid).classList.add("active");
			}	
			if(res.message){
				document.querySelector("#star-"+row.projectid).classList.remove("active");
			}	
			
		});
		
	}
	const handleRowsPerPageChange = (rows) => {
		saveRows(rows);
	}
	const handleEditProject = (row) => {
		
		setSettingsDialog({open:true, project:structuredClone(row)});
	}
	const handleSaveProject = (proj) => {
		
		var newData = structuredClone(data);
				
		const idx = newData.projects.findIndex((p)=>{return p.projectid == proj?.projectid});
		
		if(idx == -1)
			return;
		
		newData.projects[idx] = {...newData.projects[idx], ...proj};
		
		
		setData(newData);
		
		
	}
	const handleCreateDocs = (row) => {
		setDialogPrompt({
			open:true,
			noConfirmation: true,
			text:{
				icon:false,
				prompt : <span>Do you want to create a Sharepoint document folder for this project? The setup takes about 5 minutes.</span>,
				yesBtn:'Create',
				title: `Create docs for "${row.name}"?`,
				successMsg: 'Request sent',
				textCss: 'dialog-prompt-text'
			},
			onConfirm: ()=>{
				
				return atlasApi.addProjectDocs(row.projectid);
				
			},
			onClose: (res)=>{
				setDialogPrompt({open:false});
				if(res && res.success){
					
					context.QN.current.show(`Request for project "${row.name}" documents sent.`);
					
				}
			}
		});
	}
	const handleRemoveProject = (row) => {
		
		
		
		setDialogPrompt({
			open:true,
			text:{
				icon:false,
				prompt : <span>This action is permanent. Recovering data requires contacting a system administrator. <br /><br />Are you sure you want to remove this project?</span>,
				yesBtn:'Remove project',
				title: `Remove project "${row.name}"?`,
				successMsg: 'The project has been removed',
				textCss: 'dialog-prompt-text'
			},
			onConfirm: ()=>{
				
				return atlasApi.deleteProject(row.projectid);
				
			},
			onClose: (res)=>{
				setDialogPrompt({open:false});
				if(res && res.success){
					var newData = structuredClone(data);
					
					const idx = newData.projects.findIndex((p)=>{return p.projectid == row.projectid});
					
					newData.projects.splice(idx, 1);
					setData(newData);
					
					context.QN.current.show(`"${row.name}" removed.`);
					
				}
			}
		});
		
	}
	const renderProjects = function (){
		
		if(data && data.projects && data.projects.length > 0 ){
		
			const filtered = data.projects.filter((item, index)=>{

				return (!filterPhase.size || filterPhase.has(item.phase))&&
						(!filterStatus.size || filterStatus.has(item.state))&&
						(!filterCountry.size || filterCountry.has(item.country)) && 
						(!filterEnergy.size || (filterEnergy.has(item.energyType))) && 
						(!filterFav || item.isFavorite) &&
						searchNeedle(item)
			});

			switch(listStyle){

				case 'card':
					closeMap();
					return renderCards(filtered);
					break;
				case 'list':
					closeMap();
					return renderList(filtered);
					break;
				case 'map':
					return initializeMap(filtered);
					break;
			}
		}
	}
	const gotoProject = (pId)=>{
		window.location.href='/pages/project/'+pId;
	}
	
	const renderCards = (data)=> {


			
			/*
			 sort code here
			 eventualy it will be necessary to change this if asc and desc become options
			*/
			data.sort((a, b) => {
				return a.name > b.name
			});
			
		
			return data.map((item, index)=>{
					return (
						
					
						<Link className="card-project-wrp" key={index} to={"/pages/project/" + item.projectid}>
							<Card className="card-project mx-3 my-2">
								<Card.Body className={"card-img-top "} style={{backgroundImage:"url('"+item.image+"')"}}>
									{item.state=="Terminated" && <div className="tint"></div>}
									{makelink( <Star data-projectid={item.projectid} onClick={(e)=>{handleSetFavorite(e, item)}} weight={(item.isFavorite ? "fill" : 'bold')} className={"m-0 fav-star "+(item.isFavorite ? "active" : '')}  size={20} />, item.projectid)}
									<Badge bg="none" style={projectStatusColors.colors(item.state)}>{item.state}</Badge>
									
									
									<Row className="statusBar">
										<Col xl="8">
											{parse(item.name.replace(new RegExp(needle, "i"), highlight))}
											<br />
											{item.lastEdited && <small>Last edited: {formatDate(item.lastEdited, "short")}</small>}
										</Col>
										<Col xl="4" className="text-end">
											{item.energyType.split(",").map((e, k)=>{return <IconSelector options={energyTypes.get(e)} />})}
											
											<img className="flag" src={'/images/icons/flags/1x1/'+Country.options.find((i)=>i.label==item.country).flag+'.svg'} />
										</Col>
									</Row>
								</Card.Body>
								
							</Card>
						</Link>
					)
			});
		
	}
	
	const makelink = (elem, pId) => {
		return <Link to={'/pages/project/'+pId}>{elem}</Link>
	}
	const sortByStringField = (
		rowA,
		rowB,
		selector,
		options
	) => {
		return sortStrings(
			selector(rowA),
			selector(rowB),
			options
		);
	};
	const renderList = (data) => {
		
		
			return (
				<DataTable
					data={data}
					columns={[


						{
							name:' ',
							id:'isFavorite',
							selector: row => row.isFavorite,
							format: row => <div className="btn p-0" onClick={(e)=>{handleSetFavorite(e, row)}}><Star id={"star-"+row.projectid} data-projectid={row.projectid} onClick={(e)=>{handleSetFavorite(e, row)}} weight={(row.isFavorite ? "fill" : 'bold')} className={"m-0 mb-1 me-1 ms-3 fav-star "+(row.isFavorite ? "active" : '')}  size={20} /> </div>,
							sortable:true,
							width:"55px !important",
						},
						{
							name:'Project name',
							id:'name',
							selector: row => row.name,
							format: row => makelink(row.name, row.projectid),
							sortable:true,
							minWidth:"200px !important",
							style:{
							}
						},
						{
							name:'Tech',
							id:'energyType',
							selector: row => row.energyType,
							sortable:true,
							format: (row) => <span data-tag="allowRowEvents"><IconSelector options={energyTypes.get(row.energyType)} /></span>,
							maxWidth:"70px",
							style:{
							}
						},
						{
							name:'Year',
							id:'vintage',
							selector: row => row.vintage,
							sortable:true,
							center: true,
							format: (row) => makelink(row.vintage, row.projectid),
							maxWidth:"70px",
							style:{
							}
						},
						{
							name:'Phase',
							id:'phase',
							selector: row => row.phase,
							sortable:true,
							format: (row) => makelink(<Badge data-tag="allowRowEvents" bg="" className="me-2 rounded" style={projectPhaseColors.colors(row.phase)}>{row.phase}</Badge>, row.projectid),
							minWidth:"150px !important",
							style:{
							}
						},
						{
							name:'State',
							id:'state',
							selector: row => row.state,
							sortable:true,
							format: (row) => makelink(<Badge data-tag="allowRowEvents" bg="" className="me-2 rounded" style={projectStatusColors.colors(row.state)}>{row.state}</Badge>, row.projectid),
							minWidth:"130px !important",
							style:{
							}
						},
						{
							name:'Potential',
							id:'size',
							selector: row => row.size,
							sortable:true,
							format: (row) => makelink(row.size.toFixed(0)+'MW', row.projectid),
							maxWidth:"100px",
							style:{
							}
						},
						{
							name:'Price region',
							id:'priceRegion',
							selector: row => row.priceRegion,
							sortable:true,
							center:true,
							sortFunction: (rowA, rowB) =>
								sortByStringField(
									rowA,
									rowB,
									row => row.priceRegion,
									{ nullsLast: true }
								),
							format: (row) => makelink(row.priceRegion, row.projectid),
							maxWidth:"110px",
							style:{
							}
						},
						{
							name:'Country',
							id:'country',
							selector: row => row.country,
							sortable:true,
							center: true,
							format: (row) => makelink(<IconSelector options={Country.get(row.country)} />, row.projectid),
							maxWidth:"100px",
							style:{
							}
						},
						{
							name:'Project owner',
							id:'owner',
							selector: row => row?.projectOwner?.name,
							sortable:true,
							sortFunction: (rowA, rowB) =>
								sortByStringField(
									rowA,
									rowB,
									row => row.projectOwner?.name,
									{ nullsLast: true }
								),
							format: (row) => makelink(<span data-tag="allowRowEvents" title={row?.projectOwner?.name}>{row?.projectOwner?.name}</span>, row.projectid),
						},
						{
							name:'Last opened',
							id:'lastOpened',
							selector: row => row.lastOpened,
							sortable:true,
							sortFunction: (rowA, rowB) => sortByDate(rowA, rowB, row => row.lastOpened),
							format: (row) => makelink(timeAgo(row.lastOpened), row.projectid),
						},
						{
							name:'Docs',
							id:'documentsURL',
							selector: row => row.documentsURL,
							sortable:true,
							format: (row) => (row.documentsURL ? <a href={row.documentsURL} target="_blank"><Files size={20} /></a> : ''),
							width:"70px",
							omit:true,
						},
						{
							name:'',
							id:'contextmenu',
							cell: row => (
								<div className="context-menu">
									<Dropdown className="minimal">
										<Dropdown.Toggle className="p-0 px-1" variant="default">
											<DotsThreeVertical size={16} />
										</Dropdown.Toggle>
										<Dropdown.Menu>

												<Dropdown.Item href="#" onClick={(e)=>{handleEditProject(row); }}><PencilSimple weight="bold" size={16} /> Edit project</Dropdown.Item>
												{false && !row.documentsURL &&
													<Dropdown.Item href="#" onClick={(e)=>{handleCreateDocs(row); }}><Files weight="bold" size={16} /> Create docs</Dropdown.Item>
												}
												<Dropdown.Item href="#" onClick={(e)=>{handleRemoveProject(row); }} className="text-danger" ><Trash weight="bold" size={16} /> Remove project</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							),
							width:"40px",
						},


					]}
					customStyles={{
						headCells:{
							style: {
								padding:'.5rem .3rem',
								minWidth:'0px !important',
								fontWeight:'bold',
								fontSize:"16px"
							}
						},
						cells:{
							style: {
								padding:'.5rem .3rem',
								fontSize:"16px",
								minWidth:'0px !important',
								color:'var(--bs-body-color)',
								'&:last-child':{paddingRight:'1rem'}
							}
						},
						rows:{
							style: {
								minHeight:"0",
							},
							selectedHighlightStyle:{
								backgroundColor:'red'
							}
						},
						pagination : {
							style : {
								width:"100%"
							}
						}
					}}
					noDataComponent=<div className="p-5">There are not projects to display</div>
					highlightOnHover
					paginationPerPage={user.settings.projects.rowsPerPage}
					sortIcon=<i className="ri-expand-up-down-line"></i>
					pagination
					onChangeRowsPerPage={handleRowsPerPageChange}
					paginationComponent = {Pagination}
					onRowClicked={(row)=>{gotoProject(row.projectid);}}
					onSort={(selectedColumn, sortDirection, sortedRows) => {saveSort(selectedColumn, sortDirection)}}
					defaultSortFieldId = { listSort.sortBy }
					defaultSortAsc = {listSort.sortOrder == 'asc'}
					paginationComponentOptions = {{
						rowsPerPageText: 'Show',
						type: 'projects',
						rangeSeparatorText: 'of',
						selectAllRowsItemText: 'All',
					}}

				/>
			)
		
	}
	const renderMap = ()=>{
		
		return (<>
					<div ref={mapContainer}  onLoad={initializeMap} className="project-map" />
					
				</>);
		
	}
	const closeMap = () => {
		
		if(du)
			du.clearMarkers();
	}
	const initializeMap = (projects) => {
		
		
		if (map.current || errors.length){
			du.drawProjects(projects);
			return; // initialize map only once
		}
		map.current = new mapboxgl.Map({
			container: mapContainer.current,
			style: 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
			center: centerPoint,
			zoom: zoom
		});
		map.current.addControl(Draw, 'bottom-left');
		
		map.current.dragRotate.disable();
		
		du		= new drawUtils(map.current, Draw);
		tc		= new turbineControl(map.current, du);
		
		map.current.on('draw.create', (e)=>setSaveBtn(true));
		map.current.on('draw.delete', (e)=>setSaveBtn(false));
		map.current.on('draw.modechange', du.handleModeChange.bind(du));
		//map.current.on('draw.actionable', (e)=>{console.log("actionable", e)});

		map.current.on('load', () => {
			du.drawProjects(projects);
			map.current.resize();
			map.current.fitBounds(TurfBBox(data.poly));
			
		});
	}
	const newProject = () => {
		return;
		return (<button onClick={()=>setAddProject(true)} className="btn btn-success ms-auto">New project</button>);

	}
	const saveFilter = (filter, value)=>{
		
		if(user && user.userDetails && user.settings){
			
			
			
			if(!user.settings.projects){
				user.settings.projects = {
					filters : {...user.settings.filters},
					listStyle : listStyle
				}
				delete user.settings.filters;
			}
			user.settings.projects.filters[filter] = value;
			
			user.email = user.userDetails;

			atlasApi.updateSettings(user);
		}
		
	}
	const saveSort = (sortBy, sortOrder)=>{
		
		if(user && user.userDetails && user.settings){
			
			
			
			if(!user.settings.projects){
				user.settings.projects = {
					filters : {...user.settings.filters},
					listStyle : listStyle
				}
				delete user.settings.filters;
			}
			user.settings.projects.sort = {
				sortOrder:sortOrder,
				sortBy:sortBy.id
			}
			user.email = user.userDetails;
			atlasApi.updateSettings(user);
		}
		
	}

	const saveView = (view)=>{
		
		if(user && user.userDetails && user.settings){
				
			if(!user.settings.projects){
				user.settings.projects = {
					filters : {...user.settings.filters},
				}
			}
			
			user.settings.projects.listStyle = view
			
			user.email = user.userDetails;

			atlasApi.updateSettings(user);
		}
		
	}
	const saveRows = (rows)=>{
		
		if(user && user.userDetails && user.settings){
				
			if(!user.settings.projects){
				user.settings.projects = {
					filters : {...user.settings.filters},
				}
			}
			
			user.settings.projects.rowsPerPage = rows
			
			user.email = user.userDetails;

			atlasApi.updateSettings(user);
		}
		
	}
	const drawProject = (e)=>{
		if(tc)
			tc.addProject(e);
	}
	const handleLayerUpload = (layer)=>{
		
		if(du && layer.features && layer.features.length){
			
			var feature = {...layer.features[0]};
			
			//const center = TurfCenterOfMass(feature.geometry).geometry.coordinates;
			
			
			feature.id = 'boundary';
			
			
			du.draw.add(feature);
			setSaveBtn(true);
			map.current.fitBounds(TurfBBox(feature));
		}
		
	}
	const handleListStyle = (style)=>{
		
		setListStyle(style);
		saveView(style);
		
	}
	const handleOtherFilters = (e) => {
		
		
		e.stopPropagation();
		
		if(showFilters)
			closeFilters();
		else
			openFilters();
		
	}
	const closeFilters = () => {
		setShowFilters(false);
		document.removeEventListener("click", closeFilters);
	}
	const openFilters = () => {
		setShowFilters(true);
		document.addEventListener("click", closeFilters);
	}
//	const openProjectDialog = (boundary)=>{
//		
//		var b = {...boundary};
//		
//		//convert polygon to multi
//		b.type = 'MultiPolygon';
//		b.coordinates = [boundary.coordinates];
//		
//		setAddProject({...addProject, open:true, boundary:b});
//				
//		
//	}
	const saveProject = (e)=>{
		
		var fc = du.draw.getAll();
		
		if(!fc.features || !fc.features.length)
			return;
		
		var b = {...fc.features[0].geometry};
		
		if(fc.features[0].geometry.type != 'MultiPolygon'){
			b.type = 'MultiPolygon';
			b.coordinates = [fc.features[0].geometry.coordinates];
		}
		setAddProject({...addProject, open:true, boundary:b});
	}
	
	const filterCount = filterPhase.size + filterStatus.size;

	return (
		<React.Fragment>

			
			

			
			
			
			
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
                
				
				<div className="middle">
					<Link to="/" className="header-logo">Energy Atlas</Link>
					<div className="header-version">{context.APP_VERSION}</div>
				</div>
				
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/allod_atlas_logo.png" alt="Allod"/>
				</div>
				<div className="options">
						{user.userId && <UserMenu user={user} onUpdateUser={setUser} />}
						
				</div>
			</div>
			<div className={"body dashboard2 " + listStyle+'-list' }>
				<Sidebar onClick={(e)=>{setShowFilters(false); e.stopPropagation();}} />
				<div className={"main projects "}>
					<Row className=" mb-3 numbers">		

						<Col>
							<label>We are currently developing</label>
							<span>{data.totalMW} MW</span>
						</Col>
						<Col>
							<label>In total we have</label>
							<span>{data.totalProjects} projects</span>
						</Col>
						<Col>
							<label>Solar</label>
							<span>{data.totalSolarProjects} projects</span>
						</Col>

						<Col>
							<label>Wind</label>
							<span>{data.totalWindProjects} projects</span>

						</Col>
						<Col>
							<label>Total signed contracts</label>
							<span>{data.totalSignedContracts} contracts</span>

						</Col>
					</Row>
					<div className="card">
						<Row className="mb-4">
							<Col xl>
								<Row className="p-3 filters">		
									<div>
										<InputGroup className="search-wrp">
											<Form.Control autoFocus  type="text" className="search-input" defaultValue={searchSel} onChange={search} placeholder="Search projects..." />
											<InputGroup.Text id="basic-addon1"><i className="ri-search-line"></i></InputGroup.Text>
										</InputGroup>
									</div>
									
									<div>
										<label>Country:</label>
										<IconSelector onClick={(vs)=>{selectFilter("country", vs, setFilterCountry)  }} value={filterCountry} options={Country.options.filter((o)=>o.value=="Bulgaria")}  />
									</div>
									<div>
										<label>Tech:</label>
										<IconSelector onClick={(vs)=>{selectFilter("energy", vs, setFilterEnergy)  }} value={filterEnergy} options={energyTypes.types}  />
									</div>
									<div>
										<label>Favorites:</label>
										
										<Star weight={(filterFav ? "fill" : 'bold')} className={"fav-star " + (filterFav ? 'active' : '')} onClick = {(vs)=>{selectFilter("favorites", !filterFav, setFilterFav) } } size={18} />
										
										
									</div>

									<div className="text-start pt-0 filter-wrp">
										<span onClick={handleOtherFilters}>
											<Sliders size={18} className="me-1" />
											{!!filterCount &&
												<span className="active-filters">{filterCount}</span>
											}
											{!filterCount &&
											<label>Other filters...</label>
											}
										</span>
										<Card onClick={(e)=>{e.stopPropagation();}} className={"projects-filter-panel shadow-sm "+(showFilters ? "d-block opacity-100" : "opacity-0")}>
											<Card.Body>
												<div className="g-3 pb-4">
													<div><b>Phase</b></div>
													<Filter ref={phaseComp} options={filterPhaseOpts} defaultValue={phaseSel.map((a)=>{return {value:a, label:a};})} onChange={(a)=>{selectFilter("phase", a.map(b=>b.value), setFilterPhase)}} placeholder="All" isSearchable={false} isMulti />
												</div>
												<div className="g-3 pb-4">
													<div><b>State</b></div>
													<Filter ref={statusComp} options={filterStatusOpts} defaultValue={statusSel.map((a)=>{return {value:a, label:a};})} onChange={(a)=>{selectFilter("status", a.map(b=>b.value), setFilterStatus)}} placeholder="All" isSearchable={false} isMulti />
												</div>
											</Card.Body>
										</Card>


									</div>
									<div>
										<ListStyle value={listStyle} onClick={handleListStyle} />
										<ExportAllProjects count={data.totalProjects} />
									</div>

								</Row>
								<Row className="g-3"></Row>
							</Col>
						</Row>
						<div className="project-list">

							
							{renderProjects()}
							<div ref={mapContainer} className="project-map" />
							
							
							{listStyle=='map' && <>
								<DialogProject user={user} state={addProject} onClose={()=>{setAddProject(false)}} />

								<div className="screening-cp">
									<Button className="add-project" onClick={(e)=>drawProject(e)} variant="light">Draw project <Polygon weight="bold" size={16} />  </Button>
									<Button className="upload-project" onClick={(e)=>setUploadLayer({open:true})} variant="light">Upload project <UploadSimple weight="bold" size={16} /> </Button>
									{
									saveBtn && <Button onClick={(e)=>saveProject(e)} variant="primary">Save project  <FloppyDisk weight="bold" size={16} />  </Button>
									}

								</div>
								<DialogUploadLayer setup={uploadLayer} title="Upload project" type="convertLayer" onUpload={(layer)=>{handleLayerUpload(layer);}} onClose={()=>{setUploadLayer({open:false});}} />
							</>
							}
							
							<DialogProjectSettings user={user}  state={settingsDialog} onClose={(data)=>{handleSaveProject(data); setSettingsDialog({open:false})}} />
							<DialogPrompt setup={dialogPrompt} />
							
							
							{/*<DialogProjectstate={addProject} onClose={()=>{setAddProject(false)}} />

							<div className="screening-cp">
								<Button className="add-project" onClick={(e)=>drawProject(e)} variant="light">Draw project <img width="24" src="/images/icons/add_boundary.svg" />  </Button>
								<Button className="upload-project" onClick={(e)=>setUploadLayer({open:true})} variant="light">Upload project <i className="ri-upload-2-line"></i> </Button>
								{
								saveBtn && <Button className="add-project" onClick={(e)=>saveProject(e)} variant="success">Save project  <i className="ri-save-line"></i>   </Button>
								}

							</div>
							<DialogUploadLayer setup={uploadLayer} title="Upload project" type="convertLayer" onUpload={(layer)=>{handleLayerUpload(layer);}} onClose={()=>{setUploadLayer({open:false});}} />*/}
						
						</div>
					</div>
					<div className="spacer"></div>

				</div>


			</div>
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			<Loader loaded={loaded} message="Loading projects..." />
		</React.Fragment>
	);
}
